import {useTranslation} from "react-i18next";
import Button from "../../components/blocks/Button";
import {useNavigate} from "react-router-dom";

function NotFoundLayout() {
    const {t}= useTranslation("Common");
    const navigate = useNavigate();
    
  return (
    <div className="d-flex flex-column justify-content-center align-items-center h-100 fw-bold text-dark gap-2">
    <div className="icon icon-block text-danger fs-100P my-4"></div>
     <div> <h2>{t("noPermission")}</h2> </div>
     <div> <p>{t("supportContact")}</p> </div>
     <div> <Button variant={"primary"} 
                   type={"button"} 
                   title={t("BackToTaskPage")}
                   label={t("BackToTaskPage")}
                   onClick={() => navigate("/home/tasks")}
                     
     />
     </div>
     
    </div>
  );
}

export default NotFoundLayout;
